import { Api } from "@core/api/api";
import { pageParams } from "@core/api/pageParams";
import { Page, PaginationOptions } from "@utils/page";
import { MediaDto, mediaFromDto } from "@domain/media/dtos";
import { Media } from "@domain/media/media";
import { Workspace } from "./workspace";
import { WorkspaceDraft } from "./workspaceDraft";

const WORKSPACE_URL = "/workspaces";

export class WorkspaceApi {
	constructor(private readonly api: Api) {}

	async list(shareroomId: string, pageOptions: PaginationOptions): Promise<Page<Workspace>> {
		const result = await this.api.get<Page<Workspace>>(
			`${WORKSPACE_URL}?groupId=${shareroomId}&${pageParams(pageOptions)}`
		);
		return result.data;
	}
	async getById(workspaceId: string): Promise<Page<Workspace>> {
		const result = await this.api.get<Page<Workspace>>(`${WORKSPACE_URL}/${workspaceId}`);
		return result.data;
	}

	async get(id: string): Promise<Workspace> {
		const result = await this.api.get<Workspace>(`${WORKSPACE_URL}/${id}`);
		return result.data;
	}

	async getBySlug(slugWorkspace: string): Promise<Workspace> {
		const result = await this.api.get<Workspace>(`${WORKSPACE_URL}?slug=${slugWorkspace}`);
		return result.data;
	}

	async listForCourse(courseId: string, pageOptions: PaginationOptions): Promise<Page<Workspace>> {
		const result = await this.api.get<Page<Workspace>>(
			`${WORKSPACE_URL}?courseId=${courseId}&${pageParams(pageOptions)}`
		);
		return result.data;
	}
	async listForQuiz(quizId: string, pageOptions: PaginationOptions): Promise<Page<Workspace>> {
		const result = await this.api.get<Page<Workspace>>(`${WORKSPACE_URL}?quizId=${quizId}&${pageParams(pageOptions)}`);
		return result.data;
	}

	async listForArticle(articleId: string, pageOptions: PaginationOptions): Promise<Page<Workspace>> {
		const result = await this.api.get<Page<Workspace>>(
			`${WORKSPACE_URL}?articleId=${articleId}&${pageParams(pageOptions)}`
		);
		return result.data;
	}

	async create(draft: WorkspaceDraft): Promise<Workspace> {
		const result = await this.api.post<Workspace>(`${WORKSPACE_URL}`, draft);
		return result.data;
	}
	async save(draft: WorkspaceDraft, id: string): Promise<Workspace> {
		const result = await this.api.put<Workspace>(`${WORKSPACE_URL}/${id}`, draft);
		return result.data;
	}
	async delete(id: string): Promise<void> {
		return this.api.delete(`${WORKSPACE_URL}/${id}`);
	}

	// async getAssets(id: string, pageOptions: PaginationOptions): Promise<Page<Media>> {
	// 	const result = await this.api.get<Page<MediaDto>>(`${WORKSPACE_URL}/${id}/assets?${pageParams(pageOptions)}`);
	// 	return { ...result.data, content: result.data.content.map((asset) => mediaFromDto(asset)) };
	// }

	// get asset by slug
	async getAssets(workspaceId: string, pageOptions: PaginationOptions): Promise<Page<Media>> {
		const result = await this.api.get<Page<MediaDto>>(
			`${WORKSPACE_URL}/${workspaceId}/assets?${pageParams(pageOptions)}`
		);
		return { ...result.data, content: result.data.content.map((asset) => mediaFromDto(asset)) };
	}

	// async addAsset(id: string, assetId: string): Promise<void> {
	// 	return this.api.post(`${WORKSPACE_URL}/${id}/assets/${assetId}`);
	// }

	// Add asset by slug workspace
	async addAsset(workspaceId: string, assetId: string): Promise<void> {
		return this.api.post(`${WORKSPACE_URL}/${workspaceId}/assets/${assetId}`);
	}

	// deleteAsset(id: string, assetId: string): Promise<void> {
	// 	return this.api.delete(`${WORKSPACE_URL}/${id}/assets/${assetId}`);
	// }

	// delete asset by slug
	deleteAsset(id: string, assetId: string): Promise<void> {
		return this.api.delete(`${WORKSPACE_URL}/slug/${id}/assets/${assetId}`);
	}

	async addCourse(id: string, courseId: string): Promise<void> {
		return this.api.post(`${WORKSPACE_URL}/${id}/courses/${courseId}`);
	}
	async deleteCourse(id: string, courseId: string): Promise<void> {
		return this.api.delete(`${WORKSPACE_URL}/${id}/courses/${courseId}`);
	}

	async addQuiz(id: string, quizId: string): Promise<void> {
		return this.api.post(`${WORKSPACE_URL}/${id}/quizzes/${quizId}`);
	}
	async deleteQuiz(id: string, quizId: string): Promise<void> {
		return this.api.delete(`${WORKSPACE_URL}/${id}/quizzes/${quizId}`);
	}
}
